export enum ChipModel {
    ESP32 = 1,
    ESP32S2 = 2,
    ESP32S3 = 9,
    ESP32C3 = 5,
    ESP32H2 = 6,
}
